import React, { Component } from "react";
import "./App.css";
import ChangePasswordForm from "./components/ChangePasswordForm";
import Downloads from "./components/Downloads";
import ForgotPassword from "./components/ForgotPassword";
import LoginForm from "./components/LoginForm";
import RegistrationForm from "./components/RegistrationForm";
import { Router, Route, Switch } from "react-router-dom";
import { PrivateRoute } from "./components/PrivateRoute";
import { history } from "./helpers/history";
import { configureUrlQuery } from "react-url-query";

configureUrlQuery({ history, addChangeHandlers: false });

class App extends Component {
  componentDidMount() {
    history.listen(() => this.forceUpdate());
  }

  render() {
    console.log("Props " + JSON.stringify(this.props));
    console.log("History is " + JSON.stringify(history));
    console.log("ENV is " + process.env.PUBLIC_URL);
    return (
      <Router basename={"/openempi-downloads"} history={history}>
        <div className="App">
          <header className="App-header">
            <br />
            <Switch>
              <PrivateRoute exact path={"/"} component={Downloads} />
              <Route path={"/login"} component={LoginForm} />
              <Route path={"/registration"} component={RegistrationForm} />
              <Route path={"/forgot"} component={ForgotPassword} />
              <Route path={"/changePassword"} component={ChangePasswordForm} />
              <Route path="*" component={LoginForm} />
            </Switch>
          </header>
          <br />
          <br />
        </div>
      </Router>
    );
  }
}

export default App;
